import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-12">
          {/* Logo and Contact - Takes full width on mobile, then 1 column */}
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mr-2 md:mr-3">
                <i className="ri-flashlight-fill text-white text-xl md:text-2xl"></i>
              </div>
              <span className="text-lg md:text-xl font-bold">Sydney Electricians</span>
            </div>
            <p className="text-gray-400 mb-4 md:mb-6 text-sm md:text-base leading-relaxed">
              Your trusted electrical experts in Sydney. Licensed, insured, and ready to help 24/7.
            </p>
            <div className="space-y-2 md:space-y-3">
              <a
                href="tel:0416497716"
                className="flex items-center text-gray-300 hover:text-orange-500 transition-colors text-sm md:text-base"
              >
                <i className="ri-phone-fill mr-2 md:mr-3 text-orange-500"></i>
                0416 497 716
              </a>
              <a
                href="mailto:info@sydneyelectricians.com.au"
                className="flex items-center text-gray-300 hover:text-orange-500 transition-colors text-sm md:text-base"
              >
                <i className="ri-mail-fill mr-2 md:mr-3 text-orange-500"></i>
                info@sydneyelectricians.com.au
              </a>
              <div className="flex items-start text-gray-300 text-sm md:text-base">
                <i className="ri-map-pin-fill mr-2 md:mr-3 text-orange-500 mt-1"></i>
                <span>Serving all Sydney suburbs</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Quick Links</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services - Spans 2 columns on mobile, 1 on desktop */}
          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Our Services</h3>
            <ul className="grid grid-cols-2 lg:grid-cols-1 gap-2 md:gap-3">
              <li>
                <Link
                  to="/services/electrical-repairs"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Electrical Repairs
                </Link>
              </li>
              <li>
                <Link
                  to="/services/lighting"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Lighting Installation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/switchboards"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Switchboard Upgrades
                </Link>
              </li>
              <li>
                <Link
                  to="/services/smoke-alarms"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Smoke Alarms
                </Link>
              </li>
              <li>
                <Link
                  to="/services/emergency-work"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Emergency Work
                </Link>
              </li>
              <li>
                <Link
                  to="/services/solar-batteries"
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm md:text-base"
                >
                  Solar & Batteries
                </Link>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Business Hours</h3>
            <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
              <li className="flex justify-between text-gray-400">
                <span>Monday - Friday:</span>
                <span className="text-white">7:00 AM - 6:00 PM</span>
              </li>
              <li className="flex justify-between text-gray-400">
                <span>Saturday:</span>
                <span className="text-white">8:00 AM - 4:00 PM</span>
              </li>
              <li className="flex justify-between text-gray-400">
                <span>Sunday:</span>
                <span className="text-white">Emergency Only</span>
              </li>
            </ul>
            <div className="mt-4 md:mt-6 p-3 md:p-4 bg-orange-500/10 border border-orange-500/20 rounded-lg">
              <p className="text-orange-400 font-semibold text-sm md:text-base">
                <i className="ri-time-line mr-2"></i>
                24/7 Emergency Service Available
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-gray-400 text-xs md:text-sm text-center md:text-left">
              © 2026 Sydney Electricians. All rights reserved. | Licensed & Insured
            </p>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
                <i className="ri-shield-check-fill text-white text-base md:text-lg"></i>
              </div>
              <span className="text-gray-400 text-xs md:text-sm">Fully Licensed Electricians</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}